import type { PermissionsLiveKitOptions } from '@hooks/classroom/permissions-live-kit.hook'

import { useLessonRoomStore } from '@stores/lesson-room'

import { usePermissionsLiveKit } from '@hooks/classroom/permissions-live-kit.hook'

import amplitudeConfig from '@config/amplitude.json'

import { trackClassroomEvent } from '@tools/amplitude/classroom'

interface UseClassroomPermissionsLiveKitReturn {
  requestPermissions: () => Promise<void>
}

export const useClassroomPermissionsLiveKit = (): UseClassroomPermissionsLiveKitReturn => {
  const lessonRoomStore = useLessonRoomStore()

  const options: PermissionsLiveKitOptions = {
    permissions: {
      setDeniedMic: (v) => lessonRoomStore.setDeniedMic(v),
      setDeniedCam: (v) => lessonRoomStore.setDeniedCam(v),
      setBlocked: (v) => lessonRoomStore.setPermissionsBlocked(v),
    },
    analytics: {
      permissionsPopUp: ({ micStatus, camStatus }) =>
        trackClassroomEvent(amplitudeConfig.events.permissionsPopUp, { mic_status: micStatus, cam_status: camStatus }),
    },
  }

  return usePermissionsLiveKit(options)
}
